import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id) {
    let url = `${window.api_url}/public/organizations/${window.organization_id}/questions`;
    if (id) {
      url += `/${id}`;
    }
    return url;
  },

  get(id, success) {
    if (!success) return axios.get(this.baseUrl(id));
    return axios.get(this.baseUrl(id)).then(success);
  },

  async index(params = {}, successCallback = null, failureCallback = null) {
    return axios
      .get(this.baseUrl(), { params })
      .then((response) => {
        if (successCallback) successCallback(response);
        return response;
      })
      .catch((error) => {
        if (failureCallback) return failureCallback(error);
        return handleError(error);
      });
  },
};
